export const SERVICE_CODE = 'NOTIFICATION' + '_SERVICE';
